<div class="video-dialog">
  <div id="youtubePlayer" [hidden]="loadFailed"></div>

  <div class="video-fallback" *ngIf="loadFailed">
    <mat-icon class="video-fallback__icon">videocam_off</mat-icon>
    <p class="video-fallback__title">The video could not be loaded here.</p>
    <p class="video-fallback__hint">
      Your network or browser may be blocking embedded YouTube players. You can still watch it on YouTube.
    </p>
    <a mat-flat-button color="primary" [href]="watchUrl" target="_blank" rel="noopener noreferrer">
      <mat-icon>open_in_new</mat-icon>
      Open on YouTube
    </a>
  </div>

  <button mat-icon-button class="close-button" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
</div>
